import { Layout, SlideoutDecorator, DataSource } from "@mcleod/components";
import { AuditLog } from "./AuditLog";
import { CommonDialogs } from "./CommonDialogs";
import { LogManager } from "@mcleod/core";

interface AuditLogSlideoutProps {
    layoutName: string,
    datasource: DataSource,
    modelName: string;
    id: string;
    includeOnlyField: string;
    doAfterSlideOut?: (success: boolean) => void;
}

const actionButtonProps = {
    caption: "Save",
    backgroundColor: "primary",
    color: "primary.reverse",
    busyWhenDataSourceBusy: true,
    paddingTop: 10,
    paddingBottom: 10,
    rowBreak: false,
    borderWidth: 0,
    minWidth: 128
}

const log = LogManager.getLogger("common.AuditLogView");

export class AuditLogView {
    private auditedDatasource: DataSource;

    public static showSlideout(props: AuditLogSlideoutProps) {
        const layout = Layout.getLayout("common/AuditLog") as AuditLog;
        layout.auditedDatasource=props.datasource;
        let description = "Audit Log for [" + props.id +"]";
        if(props.includeOnlyField){
            description += " for field [" + props.includeOnlyField + "]";
        }
        new SlideoutDecorator({
            layout,
            width: '825px',
            title: description,
            displayOverlay: true,
            backgroundColor: "defaultBackground",
            fillVerticalSpace: true,
            overlayProps: { greyedBackground: true },
            layoutLoadListeners: () => {
                layout.sourceAuditLogTx.search({ layout_name: props.layoutName, model_name: props.modelName, primary_key_values: props.id, field_name: props.includeOnlyField});
            }
        });
    }

    public static showAudit(layoutName:string, datasource:DataSource, field?:string){
        const activeRow = datasource.activeRow;
        AuditLogView.showAuditForRow(layoutName, datasource, activeRow, field);
    }

    public static showAuditForRow(layoutName:string, datasource:DataSource, row:any, field?:string){
        try{
        const keyFields:string[] = row.getMetadata().keyFields;
        const values = keyFields.map((keyField) => row.get(keyField));
        const primaryKeyValues=values.join("|");
        AuditLogView.showSlideout({
            datasource: datasource,
            modelName: datasource.url,
            id: primaryKeyValues,
            layoutName: layoutName,
            includeOnlyField: field,
            doAfterSlideOut: async (success: boolean = false) => {
                if (success) {
                    console.log("success")
                }
            }
        });
        }catch(error){
            log.error(error);
            CommonDialogs.showError("Audit log is not available for this item");
        }
    }
}
